import $ from 'jquery';
import { disableElement } from '../utils/input';
const ELEMENT_SELECTOR = '.js__visible-field-by-conditions';
export class VisibleFieldsByConditions {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        if (!$elements.length) {
            return;
        }
        this.initActions($elements);
    }
    static initActions($elements) {
        $elements.each((index, element) => {
            const $element = $(element);
            const $input = $($(element).data('not-be-empty-field'));
            const $differsFromInitialValueField = $($(element).data('differs-from-initial-value-field'));
            const triggerOnChangesOnSelector = $(element).data('trigger-on-changes-on');
            $input.on('change', e => {
                this.calculateFieldVisibility($element);
            });
            $differsFromInitialValueField.on('keyup change', e => {
                this.calculateFieldVisibility($element);
            });
            if (triggerOnChangesOnSelector) {
                $('body').on('change keyup', triggerOnChangesOnSelector, e => {
                    this.calculateFieldVisibility($element);
                });
            }
            this.calculateFieldVisibility($element);
        });
    }
    static calculateFieldVisibility($element) {
        const $shouldBeValidField = $($element.data('valid-field'));
        const $shouldNotBeEmptyField = $($element.data('not-be-empty-field'));
        const shouldBeDifferentFromInitialValue = $element.data('value-differs-from-initial-value');
        const $differsFromInitialValueField = $($element.data('differs-from-initial-value-field'));
        const hasError = $shouldBeValidField.closest('.field').hasClass('error');
        const isDifferentFormInitial = shouldBeDifferentFromInitialValue &&
            $differsFromInitialValueField.data('initial-value') &&
            Number($differsFromInitialValueField.val()) !== Number($differsFromInitialValueField.data('initial-value'));
        const isDisabled = !$shouldNotBeEmptyField.val() || hasError || !isDifferentFormInitial;
        disableElement($element, isDisabled, '', false, true);
    }
}
